import React, { FC } from "react";
import { Button } from "@material-ui/core";
import { postRequest } from "../../../apis/axiosAction";
import Encoding from "encoding-japanese";
import { DateTime } from "luxon";

// 小計を表示する場所が何番目か
const itemTotalCountList = [15, 27, 37, 50];
const MAX_ITEM_COUNT = 50;

const OneVisionStoreScoreDataButton: FC<{
  csvZoCode?: string;
  csvDoCode?: string;
  addMonth: number;
}> = ({ csvZoCode, csvDoCode, addMonth }) => {
  const [executeFlg, setExecuteFlg] = React.useState(false);
  const [executeFlg2, setExecuteFlg2] = React.useState(false);
  const [searchZoCode] = React.useState(csvZoCode);
  const [searchDoCode] = React.useState(csvDoCode);

  // 個店毎の得点推移
  const getOneVisionData = async () => {
    let date: any = DateTime.local().toFormat("yyyyMMdd");

    const apiParams = {
      "api-name": "storeTransitionData-phase2",
      target_date: "selectedBaseDate",
      zo_code: searchZoCode,
      do_code: searchDoCode,
    };
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 +
      "onevision/storeTransitionData-phase2";

    setExecuteFlg(true);
    return postRequest(url, apiParams)
      .then((res) => {
        let headerRow: any[] = [
          "ZOコード",
          "ZO",
          "DOコード",
          "DO",
          "OFCコード",
          "OFC",
          "店舗コード",
          "店舗名",
        ];

        let dataList: any[] = res.data.dataList;
        let sortDataList: any[] = [];
        if (dataList) {
          let resultList = dataList[0].resultList;
          let monthList = dataList[0].monthList;

          for (let j = 0; j < monthList.length; j++) {
            headerRow.push(monthList[j].name.slice(1));
          }
          for (let i = 0; i < resultList.length; i++) {
            let sortData: any = {};
            let result: any = resultList[i];
            sortData.zocode = result.zocode;
            sortData.zoname = result.zoname;
            sortData.docode = result.docode;
            sortData.doname = result.doname;
            sortData.ofc_code = result.ofc_code;
            sortData.ofc_name = result.ofc_name;
            sortData.tenpo_code = result.tenpo_code;
            sortData.tenpo_name = result.tenpo_name;
            for (let j = 0; j < monthList.length; j++) {
              sortData[monthList[j].name] = result[monthList[j].name];
            }
            sortDataList.push(sortData);
          }
        }

        const dataRows = sortDataList.map(({ tableData, ...row }) => {
          return Object.values(row);
        });

        const delimiter = ",";
        const data: any = [headerRow, ...dataRows]
          .map((e: any) => e.join(delimiter))
          .join("\n");

        let fileName = "OneVisionStoreTransitionData_" + date;

        const exportFileName = `${fileName}.csv`;

        let convertData: any = new Uint8Array(
          Encoding.convert(Encoding.stringToCode(data), "SJIS", "UNICODE")
        );
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
          new Blob([convertData], { type: "text/csv" })
        );
        a.setAttribute("download", exportFileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .finally(() => {
        setExecuteFlg(false);
      });
  };

  // 個店毎評価一覧出力
  const getStoreScoreData = async () => {
    let date: any = DateTime.local().toFormat("yyyyMMdd");
    const apiParams = {
      "api-name": "storeEvaluationData-phase2",
      target_date: addMonth,
      zo_code: searchZoCode,
      do_code: searchDoCode,
    };
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 +
      "onevision/storeEvaluationData-phase2";

    setExecuteFlg2(true);
    return postRequest(url, apiParams)
      .then((res) => {
        let headerRow: any[] = [
          "提出日",
          "ZOコード",
          "ZO",
          "DOコード",
          "DO",
          "OFCコード",
          "OFC",
          "店舗コード",
          "店舗名",
        ];
        let categorySum: any[] = [
          "①働きたいお店づくり　小計",
          "②人材確保・初期教育　小計",
          "③従業員戦力化　小計",
          "遵守項目　小計（0点満点）",
        ];
        let categoryIdx = 0;
        for (let i = 1; i <= MAX_ITEM_COUNT; i++) {
          headerRow.push("No" + i);
          if (itemTotalCountList.includes(i)) {
            headerRow.push(categorySum[categoryIdx]);
            categoryIdx++;
          }
        }
        headerRow.push("課題");
        headerRow.push("対策");
        headerRow.push("必要人時／日");
        headerRow.push("不足人時／日");
        headerRow.push("必要人時／週");
        headerRow.push("不足人時／週");
        headerRow.push("従業員人数");
        headerRow.push("採用人数");
        headerRow.push("退職人数");
        headerRow.push("三六協定");
        headerRow.push("就業規則");

        let dataList: any[] = res.data.dataList;
        let sortDataList: any[] = [];
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let sortData: any = {};
            let result: any = dataList[i];
            sortData.approve_day = result.approve_day;
            sortData.zocode = result.zocode;
            sortData.zoname = result.zoname;
            sortData.docode = result.docode;
            sortData.doname = result.doname;
            sortData.ofc_code = result.ofc_code;
            sortData.ofc_name = result.ofc_name;
            sortData.tenpo_code = result.tenpo_code;
            sortData.tenpo_name = result.tenpo_name;
            categoryIdx = 1;
            for (let j = 1; j <= MAX_ITEM_COUNT; j++) {
              sortData["_" + j] = result["_" + j];
              if (itemTotalCountList.includes(j)) {
                sortData["sum_" + categoryIdx] = result["sum_" + categoryIdx];
                categoryIdx++;
              }
            }
            sortData.task = '"' + result.task + '"';
            sortData.measures = '"' + result.measures + '"';
            sortData.necessary_man_hour_date = result.necessary_man_hour_date;
            sortData.shortage_man_hour_date = result.shortage_man_hour_date;
            sortData.necessary_man_hour_week = result.necessary_man_hour_week;
            sortData.shortage_man_hour_week = result.shortage_man_hour_week;
            sortData.employee = result.employee;
            sortData.recruit = result.recruit;
            sortData.retire = result.retire;
            sortData.agreement_day = result.agreement_day;
            sortData.regulation_day = result.regulation_day;
            sortDataList.push(sortData);
          }
        }

        const dataRows = sortDataList.map(({ tableData, ...row }) => {
          return Object.values(row);
        });
        const delimiter = ",";
        const data: any = [headerRow, ...dataRows]
          .map((e: any) => e.join(delimiter))
          .join("\n");

        let fileName = "OneVisionStoreEvaluationData_" + date;

        const exportFileName = `${fileName}.csv`;

        let convertData: any = new Uint8Array(
          Encoding.convert(Encoding.stringToCode(data), "SJIS", "UNICODE")
        );
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
          new Blob([convertData], { type: "text/csv" })
        );
        a.setAttribute("download", exportFileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .finally(() => {
        setExecuteFlg2(false);
      });
  };

  return (
    <>
      {addMonth === 0 ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ width: "220px", marginRight: "10px" }}
          onClick={() => getOneVisionData()}
          disabled={executeFlg ? true : false}
        >
          {!executeFlg ? "「個店毎の得点推移」CSV出力" : "CSV出力中"}
        </Button>
      ) : (
        ""
      )}
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ width: "250px", marginRight: "10px" }}
        onClick={() => getStoreScoreData()}
        disabled={executeFlg2 ? true : false}
      >
        {!executeFlg2
          ? addMonth === 0
            ? "今月分「個店毎評価一覧」CSV出力"
            : "先月分「個店毎評価一覧」CSV出力"
          : "CSV出力中"}
      </Button>
    </>
  );
};
export default OneVisionStoreScoreDataButton;
